export * from './22_qgjtjycxsjjd.component';